"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const src_1 = require("@rover/ts-bootstrap/dist/src");
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const LoadingIndicator_1 = require("../../home/LoadingIndicator");
const MobilePopover_1 = require("../components/MobilePopover");
class SegmentSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSegments: [],
        };
        this.addSelectedSegments = this.addSelectedSegments.bind(this);
        this.cancelSegmentSelect = this.cancelSegmentSelect.bind(this);
        this.getIsSegmentChecked = this.getIsSegmentChecked.bind(this);
        this.renderAddButton = this.renderAddButton.bind(this);
        this.renderBadge = this.renderBadge.bind(this);
        this.setState = this.setState.bind(this);
        this.setSelectedSegment = this.setSelectedSegment.bind(this);
    }
    componentWillMount() {
        const { fetchAudienceSizes } = this.props;
        fetchAudienceSizes();
    }
    addSelectedSegments() {
        const { addEditableSegmentIds, closePopoverModalForm, device, updateActivePopover } = this.props;
        const { selectedSegments } = this.state;
        addEditableSegmentIds(selectedSegments);
        closePopoverModalForm();
        setTimeout(() => updateActivePopover(''), device === 'Mobile' ? 500 : 0);
        this.setState({ selectedSegments: [] });
    }
    cancelSegmentSelect() {
        const { closePopoverModalForm, device, updateActivePopover } = this.props;
        this.setState({ selectedSegments: [] });
        closePopoverModalForm();
        setTimeout(() => updateActivePopover(''), device === 'Mobile' ? 500 : 0);
    }
    getIsSegmentChecked(segmentId) {
        const { selectedSegments } = this.state;
        return selectedSegments.includes(segmentId);
    }
    setSelectedSegment(segmentId) {
        const { selectedSegments } = this.state;
        if (this.getIsSegmentChecked(segmentId)) {
            return this.setState({
                selectedSegments: selectedSegments.filter((segment) => segment !== segmentId),
            });
        }
        return this.setState({
            selectedSegments: [...selectedSegments, segmentId],
        });
    }
    renderSegmentChecklist() {
        const { device, editableTriggerSegment, unselectedSegments } = this.props;
        if (unselectedSegments.length === 0) {
            return (React.createElement("div", { style: {
                    height: 'auto',
                    width: 385,
                    padding: device === 'Mobile' ? '0px 24px' : '16px',
                    display: 'flex',
                    alignItems: device === 'Mobile' ? 'flex-start' : 'center',
                    textAlign: 'center',
                } },
                React.createElement(src_1.Text, { size: "large", text: editableTriggerSegment && editableTriggerSegment.ids.length > 0
                        ? 'All segments added'
                        : 'No segments found. Manage segments in the Audience App.' })));
        }
        return (React.createElement("div", { style: {
                flex: '1 1 auto',
                paddingBottom: device === 'Mobile' ? 56 : 0,
            } },
            React.createElement(src_1.SelectableList, { device: device }, unselectedSegments.map(({ name, segmentId }, index) => (React.createElement("div", { key: index, style: {
                    alignItems: 'center',
                    display: 'flex',
                    height: device === 'Mobile' ? 72 : 56,
                    justifyContent: 'space-between',
                    width: device === 'Mobile' ? '100%' : 352,
                }, onClick: () => this.setSelectedSegment(segmentId) },
                React.createElement(src_1.Text, { text: name, size: device === 'Mobile' ? 'large' : 'medium' }),
                React.createElement(src_1.CheckBox, { checked: this.getIsSegmentChecked(segmentId), onClick: this.setSelectedSegment, value: segmentId })))))));
    }
    renderAddButton() {
        const { device, editableTriggerSegment, updateActivePopover } = this.props;
        if (editableTriggerSegment === null) {
            return;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    height: 24,
                    width: 4,
                    background: src_1.quartz,
                    marginLeft: 24,
                } }),
            React.createElement("div", { style: {
                    width: 145,
                    height: 24,
                    display: 'flex',
                    alignItems: 'center',
                } },
                React.createElement("div", { style: {
                        width: 24,
                        height: 24,
                        borderRadius: 4,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: src_1.turquoise,
                        marginRight: 8,
                        marginLeft: 14,
                    } },
                    React.createElement(src_1.PlusIcon, { fill: src_1.white })),
                React.createElement(src_1.Button, { text: "Add Segment", mouseDownColors: {
                        active: src_1.turquoise,
                        inactive: src_1.aquamarine,
                    }, onClick: device !== 'Desktop' ? () => updateActivePopover('segment-select') : undefined, type: "regular" }))));
    }
    renderAudienceList() {
        const { audience, editableTriggerSegment, isAudienceSizeUpdating, removeEditableSegmentId, segments } = this.props;
        const { Fragment } = React;
        const getSegment = (id) => segments.find((s) => s.segmentId === id);
        const getArchivedLabel = (id) => (getSegment(id).isArchived ? '(Archived)' : '');
        return (editableTriggerSegment &&
            editableTriggerSegment.ids.map((segment, index) => (React.createElement(Fragment, { key: index },
                React.createElement(src_1.List, { separationElement: index > 0 && this.renderBadge() },
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                        } },
                        React.createElement(src_1.Text, { text: `${getSegment(segment).name} ${getArchivedLabel(segment)}`, size: "medium" }),
                        !isAudienceSizeUpdating ? (React.createElement(src_1.Text, { text: `${audience[segment]} devices`, label: true, size: "small" })) : (React.createElement(LoadingIndicator_1.default, null))),
                    React.createElement(src_1.CircleCloseIcon, { fill: src_1.silver, onClick: (e) => {
                            e.stopPropagation();
                            removeEditableSegmentId(segment);
                        } }))))));
    }
    renderSegmentList() {
        const { editableTriggerSegment } = this.props;
        return (React.createElement("div", null, editableTriggerSegment
            ? editableTriggerSegment.ids.map((_, index) => React.createElement("div", { key: index }, "segmentId"))
            : ''));
    }
    renderBadge() {
        const { editableTriggerSegment } = this.props;
        const { condition } = editableTriggerSegment;
        return React.createElement(src_1.Badge, { color: src_1.steel, text: condition === 'ANY' ? 'OR' : 'AND' });
    }
    render() {
        const { activePopover, device, isPopoverModalFormOpen, updateActivePopover } = this.props;
        const { selectedSegments } = this.state;
        return device !== 'Mobile' ? (React.createElement("div", null,
            React.createElement("div", { style: { overflowY: 'scroll' } }, this.renderAudienceList()),
            React.createElement(src_1.PopoverContainer, { id: "segment-selector-popover", popoverProps: {
                    placement: 'right-end',
                    device: device,
                    navBarProperties: {
                        buttonLeft: 'Cancel',
                        buttonLeftCallback: this.cancelSegmentSelect,
                        buttonRight: selectedSegments.length > 0 ? 'Add' : '',
                        buttonRightCallback: selectedSegments.length > 0 ? this.addSelectedSegments : undefined,
                    },
                }, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', onClick: () => updateActivePopover(activePopover === 'segment-select' ? '' : 'segment-select'), showPopover: activePopover === 'segment-select' },
                this.renderAddButton(),
                React.createElement("div", { style: { height: 233, overflowY: 'scroll' } }, this.renderSegmentChecklist())))) : (React.createElement("div", null,
            this.renderAudienceList(),
            this.renderAddButton(),
            activePopover === 'segment-select' &&
                ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: {
                        buttonLeft: 'Cancel',
                        buttonLeftCallback: this.cancelSegmentSelect,
                        buttonRight: selectedSegments.length > 0 ? 'Add' : '',
                        buttonRightCallback: selectedSegments.length > 0 ? this.addSelectedSegments : undefined,
                    } },
                    React.createElement("div", { style: {
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            overflowY: 'scroll',
                        } },
                        React.createElement(src_1.Text, { text: "Add segments", size: "h2", textStyle: { margin: 24, marginBottom: 8 } }),
                        this.renderSegmentChecklist())), document.getElementById('mainModalLeft'))));
    }
}
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    audience: reducers_1.getAudience(state),
    editableTriggerSegment: reducers_1.getEditableCampaignSegment(state),
    editableUIState: reducers_1.getEditableUIState(state),
    isAudienceSizeUpdating: reducers_1.getIsAudienceSizeUpdating(state),
    isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
    segments: reducers_1.getAllSegments(state),
    unselectedSegments: reducers_1.getUnselectedSegments(state),
});
const mapDispatchToProps = (dispatch) => ({
    addEditableSegmentIds: (segmentIds) => dispatch(actions_1.addEditableSegmentIds(segmentIds)),
    closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    fetchAudienceSizes: () => dispatch(actions_1.fetchAudienceSizes()),
    removeEditableSegmentId: (segmentId) => dispatch(actions_1.removeEditableSegmentId(segmentId)),
    updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
    updateEditableUIState: (newUIStateGroup, newUIStateValue) => dispatch(actions_1.updateEditableUIState(newUIStateGroup, newUIStateValue)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SegmentSelector);
